export class CustomError extends Error {
  constructor(message: string) {
    super(message);
  }

  toString() {
    return this.message;
  }
}

export class MusicTokenExpiredError extends Error {
  constructor() {
    super("Music token expired");
  }

  toString() {
    return this.message;
  }
}
